import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { dsClass } from '../../../../../common/constants/dsClasses.js';
import { paths } from '../../../../../common/constants/pathVariables.js';
import { ModelType, VirtualModelType } from '../../../../../common/enums.js';
import { internetSubscriptionsMsg, omaElisaForCompaniesMsg, t } from '../../../../../common/i18n/index.js';
import { AnalyticsEventOrigins } from '../../../../../common/utils/analyticsUtils';
import { BreadCrumbsWithTitle } from '../../../../../components/BreadCrumbsWithTitle/BreadCrumbsWithTitle.js';
import { Grid } from '../../../../../components/Grid/Grid.js';
import { CardSelectionHeader } from '../../../../../components/OrderSubscriptionSelection/CardSelectionHeader.js';
import { Disclaimer } from '../../../../../components/OrderSubscriptionSelection/Disclaimer.js';
import { MobileBroadbandAlternativesSummary } from '../../../../../components/OrderSubscriptionSelection/MobileBroadbandAlternativesSummary.js';
import { SubscriptionCardsByModelTypeWrapper } from '../../../../../components/OrderSubscriptionSelection/SubscriptionCardsByModelTypeWrapper.js';
import { MbbSubscriptionSelectionSectionId } from '../../../../../components/OrderSubscriptionSelection/content/variables';
import { applyWizardEvent } from '../../../../../selfservice/actions/index.js';
import { OrderSubscriptionSelectionHeader } from './OrderSubscription/OrderSubscriptionSelectionHeader.js';

export const BroadbandSubNewPath = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(applyWizardEvent(1, 'NEW_MOBILE_BROADBAND'));
  }, [dispatch]);

  return (
    <>
      <OrderSubscriptionSelectionHeader
        breadCrumbs={
          <BreadCrumbsWithTitle
            breadCrumbPaths={[
              { name: t.VCUZ(omaElisaForCompaniesMsg), path: paths.SELF_SERVICE_HOME },
              { name: t.SEYV(internetSubscriptionsMsg), path: paths.PS_BROADBAND_SUBSCRIPTIONS },
              { name: t.O222('New mobile broadband subscription') },
            ]}
          />
        }
      />
      <Grid>
        <div className={`${dsClass.MARGIN_TOP_6} ${dsClass.PADDING_BOTTOM_7}`}>
          <CardSelectionHeader onlineModelType={ModelType.MobileBroadband} />
        </div>
      </Grid>
      <Grid>
        <MobileBroadbandAlternativesSummary />
      </Grid>
      <div id={MbbSubscriptionSelectionSectionId.YRITYSDATA_SUBS_ID}>
        <SubscriptionCardsByModelTypeWrapper
          onlineModelType={ModelType.MobileBroadband}
          wide
          eventOrigin={AnalyticsEventOrigins.OMAELISA}
        />
      </div>
      <div id={MbbSubscriptionSelectionSectionId.WIFI_SUBS_ID}>
        <SubscriptionCardsByModelTypeWrapper
          onlineModelType={VirtualModelType.LiikkuvaWifi}
          wide
          eventOrigin={AnalyticsEventOrigins.OMAELISA}
        />
      </div>
      <Grid>
        <Disclaimer />
      </Grid>
    </>
  );
};
